var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 0.833336C7.17992 0.833336 0.833252 7.18 0.833252 15C0.833252 22.82 7.17992 29.1667 14.9999 29.1667C22.8199 29.1667 29.1666 22.82 29.1666 15C29.1666 7.18 22.8199 0.833336 14.9999 0.833336ZM14.9999 26.3333C8.75242 26.3333 3.66659 21.2475 3.66659 15C3.66659 8.7525 8.75242 3.66667 14.9999 3.66667C21.2474 3.66667 26.3333 8.7525 26.3333 15C26.3333 21.2475 21.2474 26.3333 14.9999 26.3333ZM15.4391 13.7817C12.9316 13.1442 12.1241 12.45 12.1241 11.4158C12.1241 10.2258 13.2433 9.39 15.0991 9.39C17.0541 9.39 17.7908 10.325 17.8474 11.7133H20.2699C20.1991 9.815 19.0374 8.0725 16.7424 7.50584V5.08334H13.4416V7.4775C11.3024 7.93084 9.58825 9.31917 9.58825 11.4583C9.58825 13.9942 11.6991 15.2692 14.7733 16.0058C17.5358 16.6575 18.0883 17.635 18.0883 18.655C18.0883 19.4058 17.5358 20.6242 15.1133 20.6242C12.8466 20.6242 11.9541 19.6042 11.8266 18.3008H9.38992C9.53158 20.7092 11.3166 22.0692 13.4416 22.5083V24.9167H16.7566V22.5508C18.9099 22.14 20.6099 20.9075 20.6241 18.6267C20.6099 15.51 17.9324 14.4333 15.4391 13.7817Z",
    fill: "#B8D8E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioLinkIcon);
export default __webpack_public_path__ + "static/media/portfolioLinkIcon.91b4e770bfef06643a1ebee4a4d79aba.svg";
export { ForwardRef as ReactComponent };